import React from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

// Small inline badge for tables/lists
export const ReviewBadge = ({ review, testid }) => {
  if (!review || !review.needs_review) return null;
  return (
    <span
      data-testid={testid || "review-badge"}
      className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-800"
      title={review.issues.map((i) => i.message).join("\n")}
    >
      <AlertTriangle className="h-3 w-3" /> Needs review
    </span>
  );
};

// Full alert block listing the issues (used on the detail page)
export const ReviewAlert = ({ review }) => {
  if (!review || !review.needs_review) return null;
  return (
    <div data-testid="review-alert" className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5">
      <div className="flex items-center gap-2 text-sm font-medium text-amber-800">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        Needs review &mdash; {review.issue_count} issue{review.issue_count > 1 ? "s" : ""} detected
      </div>
      <ul className="mt-1.5 space-y-1 pl-6 list-disc text-xs text-amber-700">
        {review.issues.map((i, idx) => (
          <li key={`${i.field || "issue"}-${i.message}-${idx}`}>{i.message}</li>
        ))}
      </ul>
      <p className="mt-1.5 pl-6 text-xs text-amber-700/80">Use &ldquo;Edit&rdquo; to correct these fields.</p>
    </div>
  );
};

export const VerifiedBadge = () => (
  <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700">
    <CheckCircle2 className="h-3 w-3" /> Edited
  </span>
);
